import { pointservActions } from '@figure/frontlib-onboarding-redux';
import { useRedux } from './';

const usePointserv = () => useRedux('pointservReducer', pointservActions);

export default usePointserv;
